import { find, get, isEmpty } from "lodash";
import omitDeep from "omit-deep-lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import ProcessStepper from "shared/components/ProcessStepper";
import Loading from "shared/components/Spin";
import { useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import { GENERAL_COST } from "utils/api/graphql/queries/general-cost";
import { SCREENS } from "utils/constants";
import View from "./View";

const steps = [
  { title: "Qualification" },
  { title: "Sélection<br />produits" },
  { title: "Devis" },
  { title: "Souscription" },
  { title: "Documents" },
  { title: "Signature<br />En attente" },
  { title: "Souscription terminée" },
];

const QuoteSent = ({ onNext, onBack, currentStatus, project }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const TRANSLATION = t("DETAIL.TEMPLATES.LAFOURGALE.QUOTE", {
    returnObjects: true,
  });

  useEffect(() => {
    const signedSubscription = find(get(project, "subscriptions", []));
    if (!isEmpty(signedSubscription))
      navigate(
        `${SCREENS.PRIVATE.BROKER.SUBSCRIPTIONS.DETAIL.path}/${signedSubscription.id}`,
      );
  }, []);

  const { data, loading: generalCostLoading } = useQuery(GENERAL_COST, {
    variables: {
      where: {
        project: { id: get(project, "id") },
        insurancePlan: { id: get(project, "fields.insurancePlans.0") },
      },
    },
  });

  const onSubmit = () => {
    const subscription = find(get(project, "subscriptions", []));
    setLoading(true);
    onNext(
      isEmpty(subscription)
        ? {}
        : {
            actionsTemplate: {
              id: get(subscription, "id"),
              status: get(subscription, "status"),
            },
          },
    );
  };

  if (generalCostLoading) return <Loading />;

  return (
    <>
      <Header key="header" title={TRANSLATION.TITLE} actions={[]} />
      <ProcessStepper
        steps={steps}
        current={+get(currentStatus, "order")}
        aria-label="Étapes du projet"
      />
      <View
        translate={TRANSLATION}
        generalCost={omitDeep(get(data, "generalCost"), "__typename")}
        project={project}
        onBack={onBack}
        next={onSubmit}
        loading={loading}
      />
    </>
  );
};

export default QuoteSent;
